import { useMemo } from 'react'
import {
  IconLessonsDefault,
  IconVolumeOnDefault,
  IconDownloadDefault,
  IconStarDefault,
  IconCheckDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import styles from './Subscription.module.scss'

export const ValuePropsList = () => {
  const { t } = useTranslation('@mc/next')

  const list = useMemo(
    () => [
      {
        icon: IconLessonsDefault,
        text: t('subscription.info.allClassesWithSeries', {
          instructors: getNumberOfInstructors(),
        }),
      },
      {
        icon: IconVolumeOnDefault,
        text: t('subscription.info.audio'),
      },
      {
        icon: IconDownloadDefault,
        text: t('subscription.info.offline'),
      },
      {
        icon: IconLessonsDefault,
        text: t('subscription.info.devices'),
      },
      {
        icon: IconStarDefault,
        text: t('subscription.info.newClasses'),
      },
      {
        icon: IconCheckDefault,
        text: t('subscription.info.moneyBack'),
      },
    ],
    [t],
  )

  return (
    <ul className='mc-overflow--hidden'>
      {list.map(({ icon: IconComponent, text }) => (
        <li key={text} className={`d-flex mc-my-3 ${styles.item}`}>
          <div>
            <IconComponent className='mc-icon--3 mc-opacity--hinted mc-mr-3' />
          </div>
          {text}
        </li>
      ))}
    </ul>
  )
}
